export const ValidateStoreBoxOrder = ({ boxOrder }) => {
  if (!boxOrder.orderItems || !boxOrder.orderItems.length) {
    return {
      error: "You need to select at least one box",
      field: "Order Items",
    };
  }
  // let totalQuantity = 0;
  for (const b of boxOrder.orderItems) {
    if (!b.quantity) {
      return {
        error: "You need to select quantity for each of the boxes",
        field: "Quantity",
      };
    }
    if (!b.box) {
      return {
        error: "You need to select a box type for each of the items",
        field: "Box",
      };
    }
    if (b.quantity > Number(100)) {
      return {
        error: "You can order upto 100 boxes of each size at a time.",
        field: "Box",
      };
    }
    // totalQuantity += Number(b.quantity);
  }

  return null;
};
